module.exports = __webpack_public_path__ + "media/application/images/icons/download-page-ac014e9866698bb626e5ffdbd0ebe234.svg";